import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../contexts/ApiContext';
import { queryKeys } from '../lib/queryClient';

export function useOnlineCount() {
  const apiClient = useApiClient();

  return useQuery({
    queryKey: queryKeys.onlineCount,
    queryFn: async () => {
      const result = await apiClient.api.realtimeControllerGetOnlineCount();
      return result.online;
    },
    refetchInterval: 30_000,
    staleTime: 15_000,
  });
}
